import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faEnvelope, faCircleInfo, faClockRotateLeft } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'
import MailingMessageList from '../../../components/MailingMessageList/MailingMessageList.js'

import { boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN } from '../../../main.js'

import '../../../main.css'
import './ManageEventMailings.css'
import './MManageEventMailings.css'

import Cookies from 'universal-cookie'


export default function ManageEventMailings() {


    var [resError, setResError] = useState("")

    const cookies = new Cookies()
    let cur_authtoken = cookies.get('authtoken')

    var [eventData, setEventData] = useState([])
    var [loadedEventData, setLoadedEventData] = useState(0)

    //TODO check permission or is manager

    var [mailMessage, setMailMessage] = useState("")
    var [mailSendPlan, setMailSendPlan] = useState(1)
    var [mailCount, setMailCount] = useState(0)
    var [mailRunId, setMailRunId] = useState("")
    var [checkDouble, setCheckDouble] = useState(0)

    var [mailHistory, setMailHistory] = useState([])
    var [loadedMailHistory, setLoadedMailHistory] = useState(0)


    const { eventid } = useParams();



    useEffect(() => {
        getEventData()
        getMailHistory()
    }, [])

    function getEventData() {

        try {
            setLoadedEventData(0)


            fetch(URL_MAINAPI + "/event/" + eventid + "?ignoreinactive=1", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {

                if (res.status == 200) {

                    setEventData(res.data)
                    setLoadedEventData(1)

                } else {
                    setEventData([])
                    setLoadedEventData(0)

                }
            })
            )

        } catch (err) {
            setEventData([])
            setLoadedEventData(0)

        }

    }

    function getMailHistory() {
        try {
            setLoadedMailHistory(0)
            fetch(URL_MAINAPI + "/mailing/history/" + eventid, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setMailHistory(Array.isArray(res.data.data) ? res.data.data : [])
                    setLoadedMailHistory(1)
                } else {
                    setMailHistory([])
                    setLoadedMailHistory(1)
                }
            }))
        } catch (err) {
            setMailHistory([])
            setLoadedMailHistory(1)
        }
    }

    function sendMails() {


        document.querySelector("#responseInfo_servererror").style.display = "none"
        document.querySelector("#responseInfo_done").style.display = "none"
        document.querySelector("#responseInfo_wronginput").style.display = "none"
        setMailCount(0)
        setMailRunId("")

        if (!checkDouble) {
            document.querySelector("#responseInfo_wronginput").style.display = "block"
            return
        }

        setCheckDouble(0)

        document.querySelector("#responseInfo_loading").style.display = "block"

        var reqbody = {
            "text": mailMessage.replace(/\n/g, "<br>"),
        }

        var mailroute = mailSendPlan ? "/mailing/sendscheduleplanmails/" : "/mailing/sendmails/"


        try {

            fetch(URL_MAINAPI + mailroute + eventid, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {

                    document.querySelector("#responseInfo_loading").style.display = "none"
                    document.querySelector("#responseInfo_servererror").style.display = "none"
                    document.querySelector("#responseInfo_done").style.display = "block"
                    setResError("");

                    setMailCount(res.data.data.attendeecount)
                    setMailRunId(res.data.data.runid)
                    getMailHistory()
                } else {
                    document.querySelector("#responseInfo_loading").style.display = "none"
                    document.querySelector("#responseInfo_servererror").style.display = "block"
                    setResError(res.data.error);
                }
            })
            )
        } catch (err) {
            document.querySelector("#responseInfo_loading").style.display = "none"
            document.querySelector("#responseInfo_servererror").style.display = "block"
            setResError(err);
        }
    }


    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Mails versenden</title>
                <meta property="og:title" content="Mailings verwalten" />
                <meta property="og:description" content="Verwalte deine Kommunikation" />
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section' style={{ paddingTop: '36px' }}>
                <div className='breadcrumb'>
                    {eventData.orgid ? <><a href={'/manage/org/' + eventData.orgid}>{eventData.organization ? eventData.organization.name : 'Organisation'}</a><FontAwesomeIcon icon={faChevronRight} /></> : <><a href='/profil'>Profil</a><FontAwesomeIcon icon={faChevronRight} /></>}
                    {loadedEventData ? <><a href={'/manage/event/' + eventid}>{eventData.name || 'Event'}</a><FontAwesomeIcon icon={faChevronRight} /></> : null}
                    <span>Mailings</span>
                </div>

                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                    style={{ marginBottom: '6px' }}
                >
                    📬 Mailings verwalten
                </motion.h1>
                {loadedEventData ? <p className='section-sub'>für <a href={"/manage/event/" + eventid}>{eventData.name}</a></p> : <Skeleton width="240px" />}

                {(eventData.active != 1) ? (
                    <div className='banner-info' style={{ background: 'var(--warn-soft)', color: 'var(--warn)', marginBottom: '16px', marginTop: '16px' }}>
                        ⚠️ Event ist inaktiv und für andere nicht aufrufbar!
                    </div>
                ) : null}

                <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '20px' }}>
                    <div className='card' style={{ padding: '28px 30px', maxWidth: '820px' }}>
                        <div className='mailings-headline'>
                            <span className='mailings-icon'><FontAwesomeIcon icon={faEnvelope} /></span>
                            <h3>📩 Neue Rundmail</h3>
                        </div>

                        <div className="field">
                            <label>Individualtext</label>
                            <textarea
                                rows="8"
                                placeholder={'Individualtext (optional bei reinem Dienstplanversand)'}
                                onChange={(e) => { setMailMessage(e.target.value) }}
                                value={mailMessage}
                            />
                        </div>

                        <label className="chb">
                            <input type="checkbox" name="planpdfchb" checked={mailSendPlan} onChange={(e) => { setMailSendPlan(!mailSendPlan) }}></input>
                            <span className="chb-mark"></span>
                            <span>Individuellen Dienstplan per E-Mail-Anhang mitschicken</span>
                        </label>
                        <label className="chb">
                            <input type="checkbox" name="checkdoublechb" checked={checkDouble} onChange={(e) => { setCheckDouble(!checkDouble) }}></input>
                            <span className="chb-mark"></span>
                            <span style={{ fontWeight: 700, color: 'var(--warn)' }}>Senden bestätigen</span>
                        </label>

                        <div className='mailings-response'>
                            <div className="mailings-banner mailings-banner-info" id="responseInfo_loading" role="status">
                                <FontAwesomeIcon icon={faCircleInfo} /> Lädt... Bitte warten...
                            </div>
                            <div className="mailings-banner mailings-banner-error" id="responseInfo_servererror" role="alert">
                                <FontAwesomeIcon icon={faCircleInfo} /> Es gab einen Fehler bei der Verarbeitung.<br />
                                Fehler: {resError}
                            </div>
                            <div className="mailings-banner mailings-banner-warn" id="responseInfo_wronginput" role="alert">
                                <FontAwesomeIcon icon={faCircleInfo} /> Du musst den Versand bestätigen!
                            </div>
                            <div className="mailings-banner mailings-banner-success" id="responseInfo_done" role="status">
                                <FontAwesomeIcon icon={faCircleInfo} /> Die E-Mails wurden in die Warteschleife gesetzt. Es werden {mailCount} E-Mails nach und nach verschickt. Es kann teilweise 1h+ dauern bei großen Mengen.<br />
                                <small>Für Debugging: RunId={mailRunId}</small>
                            </div>
                        </div>

                        <div style={{ marginTop: '18px' }}>
                            <CTAButton variant="primary" hideArrow={false} title="Rundmail verschicken" onclick={() => sendMails()} />
                        </div>
                    </div>
                </motion.div>

                <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '24px' }}>
                    <div className='card mailings-history-card' style={{ padding: '28px 30px', maxWidth: '820px' }}>
                        <div className='mailings-headline'>
                            <span className='mailings-icon'><FontAwesomeIcon icon={faClockRotateLeft} /></span>
                            <h3>Letzte Nachrichten</h3>
                        </div>
                        <p className='mailings-history-hint'>Übersicht der Rundmails, die Manager für dieses Event versendet haben.</p>

                        <MailingMessageList
                            items={mailHistory}
                            loaded={!!loadedMailHistory}
                            emptyText="Noch keine Nachrichten versendet."
                            showRecipients
                            showRunId
                        />
                    </div>
                </motion.div>
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
